import { useEffect, useState } from 'react';

const initBeforeUnLoad = (showExitPrompt: boolean) => {
  window.onbeforeunload = (event: BeforeUnloadEvent) => {
    if (showExitPrompt) {
      const e = event || window.event;
      e.preventDefault();
      if (e) {
        e.returnValue = '';
      }
      return '';
    }
  };
};

function usePrompt(isDetectedAction = false) {
  const [showPrompt, setShowPrompt] = useState(isDetectedAction);

  window.onload = function () {
    initBeforeUnLoad(showPrompt);
  };

  useEffect(() => {
    initBeforeUnLoad(showPrompt);
  }, [showPrompt]);

  return [showPrompt, setShowPrompt] as const;
}

export default usePrompt;
